import { WebUrl } from "../../util/Constant";

const Menu = [
    { path: WebUrl._DASHBOARD, icon: 'fa fa-th', title: 'Dashboard' },
]

export default Menu;
